import React from 'react'
import { visibleStatuses } from './model'

// One chip per status with the backend's count. `all` is the four lead
// statuses; Blocked at intake never became a lead and is counted apart.
export default function StatusChips({ counts, active, onChange }) {
  return (
    <div role="group" aria-label="Status" style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {visibleStatuses(counts, active).map((s) => (
        <button
          key={s.id}
          type="button"
          className="li-chip"
          aria-pressed={active === s.id}
          onClick={() => { if (active !== s.id) onChange(s.id) }}
        >
          {s.label}
          <span className="li-count">{Number(counts?.[s.id] || 0).toLocaleString('en-US')}</span>
        </button>
      ))}
    </div>
  )
}
